const S3_PUBLIC_DOMAIN =
  import.meta.env.VITE_S3_PUBLIC_DOMAIN || "http://localhost:4566/gym-imagenes";

export const getResourceUrl = (key: string | null | undefined): string => {
  if (!key) return "/assets/images/default-placeholder.png";
  if (key.startsWith("http")) return key;
  const cleanKey = key.startsWith("/") ? key.substring(1) : key;
  return `${S3_PUBLIC_DOMAIN}/${cleanKey}`;
};
